module.exports = __webpack_public_path__ + "e4486ef61d5ab94b453acfa1a8d0c25d.svg";